import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SpriteIcon from '../../core-components/assets/Icon';

const noDataContainerStyles = {
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  minHeight: 200,
  overflow: 'hidden',
};

/** Wrapper constrains the SVG so it fits within the area without overflowing */
const noDataIconWrapperStyles = {
  flexShrink: 0,
  width: '100%',
  maxWidth: 280,
  height: 220,
  maxHeight: 'min(280px, 45vh)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export interface NoDataViewProps {
  message?: string;
  /** Optional container sx overrides */
  containerSx?: object;
}

const NoDataView: React.FC<NoDataViewProps> = ({
  message,
  containerSx = {},
}) => {
  const { t } = useTranslation();
  const resolvedMessage = message ?? t('common.noDataAvailable', 'No data available');
  return (
  <Box sx={{ ...noDataContainerStyles, ...containerSx }}>
    <Box sx={noDataIconWrapperStyles}>
      <SpriteIcon
        id="no_data_available_widget"
        style={{
          width: '100%',
          height: '100%',
          maxWidth: '100%',
          maxHeight: '100%',
        }}
        preserveAspectRatio="xMidYMid meet"
      />
    </Box>
    <Typography variant="subtitle1" color="textSecondary" align="center" sx={{ mt: 1 }}>
      {resolvedMessage}
    </Typography>
  </Box>
  );
};

export default NoDataView;
